// src/Pages/Dashboard/Sales/ViewInvoices.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom"; // ← Added useNavigate
import "./ViewInvoices.css";
import { API_URL } from "../../../config";

const ViewInvoices = () => {
  const { id } = useParams();
  const navigate = useNavigate(); // ← For back navigation
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const res = await fetch(`${API_URL}/api/invoices/${id}`, {
          credentials: "include",
        });

        // ADD THIS CHECK — VERY IMPORTANT
        if (!res.ok) {
          const text = await res.text();
          console.error(
            "HTML received instead of JSON:",
            text.substring(0, 200)
          );
          throw new Error(`HTTP ${res.status} - Probably wrong URL`);
        }

        const data = await res.json();
        if (data.success) {
          setInvoice(data.data);
        } else {
          console.error("Invoice not found:", data);
        }
      } catch (err) {
        console.error("Error fetching invoice:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchInvoice();
  }, [id]);

  if (loading) return <div className="loading">Loading...</div>;
  if (!invoice) return <div className="error">Invoice not found</div>;

  const subtotal = invoice.items.reduce((s, i) => s + i.amount, 0);
  const discount =
    invoice.discountType === "%"
      ? (subtotal * invoice.discountValue) / 100
      : invoice.discountValue;
  const tdsTcs = invoice.tdsTcs ? (subtotal * invoice.tdsTcsPercent) / 100 : 0;
  const total = subtotal - discount - tdsTcs + invoice.adjustment;

  return (
    <div className="view-invoice-page">
      <div className="invoice-print-container">
        {/* Header */}
        <div className="invoice-header-section">
          <div className="company-details">
            <h1>Your Company</h1>
            <p>123 Business St, City, State</p>
          </div>
          <div className="invoice-title">
            <h1>INVOICE</h1>
          </div>
        </div>

        {/* Meta */}
        <div className="invoice-meta-grid">
          <div>
            <strong>Invoice #</strong>
            <br />
            {invoice.invoiceNo}
          </div>
          <div>
            <strong>Date</strong>
            <br />
            {new Date(invoice.invoiceDate).toLocaleDateString("en-IN")}
          </div>
          <div>
            <strong>Due Date</strong>
            <br />
            {new Date(invoice.dueDate).toLocaleDateString("en-IN")}
          </div>
          <div>
            <strong>Status</strong>
            <br />
            <span
              className={`status-badge ${
                invoice.status === "PAID"
                  ? "bg-green-100 text-green-800"
                  : invoice.status === "DRAFT"
                  ? "bg-gray-100 text-gray-800"
                  : "bg-blue-100 text-blue-800"
              }`}
            >
              {invoice.status}
            </span>
          </div>
        </div>

        {/* Bill & Ship */}
        <div className="bill-ship-section">
          <div>
            <strong>Bill To</strong>
            <br />
            {invoice.customerName}
            <br />
            <small>(Customer details can be enhanced later)</small>
          </div>
          <div>
            <strong>Ship To</strong>
            <br />
            Same as billing
          </div>
        </div>

        {/* Items Table */}
        <table className="items-table-print">
          <thead>
            <tr>
              <th>ITEM</th>
              <th>QTY</th>
              <th>RATE</th>
              <th>AMOUNT</th>
            </tr>
          </thead>
          <tbody>
            {invoice.items.map((item, i) => (
              <tr key={i}>
                <td>{item.description}</td>
                <td>{item.qty}</td>
                <td>₹{item.rate.toFixed(2)}</td>
                <td>₹{item.amount.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Totals */}
        <div className="totals-section">
          <div className="totals-left">
            <div>Subtotal</div>
            <div>
              Discount ({invoice.discountValue}
              {invoice.discountType})
            </div>
            {invoice.tdsTcs && <div>TDS/TCS ({invoice.tdsTcsPercent}%)</div>}
            <div>Adjustment</div>
            <div className="grand-total">Total</div>
          </div>
          <div className="totals-right">
            <div>₹{subtotal.toFixed(2)}</div>
            <div>-₹{discount.toFixed(2)}</div>
            {invoice.tdsTcs && <div>-₹{tdsTcs.toFixed(2)}</div>}
            <div>₹{invoice.adjustment.toFixed(2)}</div>
            <div className="grand-total">₹{total.toFixed(2)}</div>
          </div>
        </div>

        {/* Notes */}
        {(invoice.customerNotes || invoice.termsConditions) && (
          <div className="notes-terms">
            <div>
              <strong>Customer Notes</strong>
              <br />
              {invoice.customerNotes || "N/A"}
            </div>
            <div>
              <strong>Terms & Conditions</strong>
              <br />
              {invoice.termsConditions || "N/A"}
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="action-buttons-print">
          <button onClick={() => window.print()} className="print-btn">
            Print
          </button>
          <button
            onClick={() => navigate("/sales/invoices")}
            className="back-btn"
          >
            Back to Invoices
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewInvoices;
